export default "__VITE_ASSET__BeJ9BDqb__"